export function filterOptionsByString(value: string, options: string[]): string[] {
  const filterValue = typeof value === 'string' ? value.toLowerCase() : value

  return options.filter((option) =>
    option.toLowerCase().includes(filterValue),
  )
}
